<template>
    <div class="c-wrapper">
        <h5 class="c-title">{{data.title}}</h5>
        <div class="c-cont-wrap">
            <!--<div v-for="item in data.list" class="c-wrap-row" :key="item">
            </div>-->
            <p v-for="(item, index) in data.list" class="c-wrap-row" :key="index"><b>{{item.name}}</b>{{item.desc}}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "cellGlossary",
    props: [ 'wrapData' ],
    watch: {
        wrapData(val) {
            // console.log(val)
        }
    },
    computed: {
        data() {
            return this.wrapData;
        },
    },
    methods: {

    },
    created() {
        // console.log('cellGlossary wrapData: ' + JSON.stringify(this.data))
    },
}
</script>

<style scoped>
/** 当前 1rem = 28px */
.c-wrapper { margin-bottom: 1rem; }
.c-cont-wrap {}
.c-title { font-weight: bold; margin-bottom: .36rem; }
.c-wrap-row { font-size: 0.43rem; line-height: 0.75rem; margin-bottom: 0.1rem; text-indent: 0; }
.c-wrap-row b { font-weight: bold; }
</style>



// WEBPACK FOOTER //
// src/components/cell-glossary.vue